import { Flex, Spinner } from "@chakra-ui/react";
import { useSelector } from "react-redux";

/**
 * TODO this spinner blocks the whole page for every API call. Which is not needed and annoying for the user.
 * TODO replace calls to showAppSpinner with local spinners and <Suspense> for loading components.
 * i.e. block the specific component that is loading, not the whole app.
 * 
 * The trigger for this spinner is: `showAppSpinner()` or isDefaultShown=true
 */
function AppSpinner({ isDefaultShown }) {
	// Note: Why does a spinner need redux? This spinner is used in the navbar -- away from the content that triggers it.
	const isShown = useSelector(state => state.appSpinner.isShown);
	if (!isShown && !isDefaultShown) return null;
	console.log("AppSpinner blocks you", isShown, isDefaultShown);
	return <Flex
		display="flex"
		position="fixed"
		alignItems="center"
		justifyContent="center"
		top="0"
		right="0"
		bottom="0"
		left="0"
		zIndex="10000"
		backgroundColor="esg_overlay"
	>
		<Spinner size="xl" />
	</Flex>;
}

export default AppSpinner;